import { Col, Dropdown, Input, Menu, Row } from 'antd';
import Colors from 'assets/Colors';
import MoreOptionHorizontal from 'components/icons/MoreOptionHorizontal';
import { useTranslation } from 'react-i18next';
import s from '../styles';

function Item({
  index,
  values,
  indexVariants,
  setFieldValue,
  deleteItem,
  setEditItem,
  editItem,
  setvariantBelongin,
  variantBelongin,
  setEditVariant,
}) {
  const { t } = useTranslation();
  function applyItemStyle(selected) {
    return {
      height: '45px',
      color: selected && Colors.text_on_secondary,
      marginBottom: '10px',
      borderRadius: '2px',
      hover: {
        backgroundColor: 'red',
        color: Colors.text_on_secondary,
      },
    };
  }

  const menu = (
    <Menu
      style={{
        overflow: 'auto',
        padding: '8px',
        paddingBottom: 0,
        minWidth: '147px',
        textAlign: 'center',
      }}
    >
      <Menu.Item
        key="delete"
        onClick={() => {
          deleteItem(indexVariants, index);
        }}
        style={{ ...applyItemStyle(), color: Colors.notification_failed }}
      >
        {t('actions.delete')}
      </Menu.Item>
    </Menu>
  );

  return (
    <Row
      onClick={() => [
        setEditItem(index),
        setvariantBelongin(indexVariants),
        setEditVariant([]),
      ]}
      key={index}
      style={{
        background:
          editItem === index && variantBelongin === indexVariants
            ? Colors.background_blurry
            : Colors.BG_MENU,
        height: '47px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Col span={1} style={{}} />
      <Col span={1} style={{}} />
      <Col span={10} style={{}}>
        <Input
          style={{ borderColor: Colors.background_dividers, width: '216px' }}
          bordered={editItem === index && variantBelongin === indexVariants}
          placeholder={t(
            'components.InventoryVariants.ListVariants.placeholderVariantAttribute'
          )}
          value={values.variants[indexVariants].items[index].name}
          onChange={(e) =>
            setFieldValue(
              `variants[${indexVariants}].items[${index}].name`,
              e.target.value
            )
          }
        />
      </Col>
      <Col span={10} style={{}}>
        <Input
          style={{ borderColor: Colors.background_dividers, width: '143px' }}
          bordered={editItem === index && variantBelongin === indexVariants}
          placeholder="in"
          value={values.variants[indexVariants].items[index].value}
          onChange={(e) =>
            setFieldValue(
              `variants[${indexVariants}].items[${index}].value`,
              e.target.value
            )
          }
        />
      </Col>
      <Col span={2} style={{}}>
        {values.variants[indexVariants].items.length > 1 && (
          <s.TableCell>
            <Dropdown
              placement="bottomRight"
              overlay={menu}
              trigger={['click']}
              arrow
            >
              <div style={{ cursor: 'pointer', height: '15px' }}>
                <MoreOptionHorizontal />
              </div>
            </Dropdown>
          </s.TableCell>
        )}
      </Col>
    </Row>
  );
}

export default Item;
